import { httpCall } from "@common/util";
import AppConstants from "@config/appConstants";
import { getAuthHeaders } from "@utils/authManager.js";
import { ACTIVITY_ENDPOINTS } from "./endpoints";

export const fetchActivityFields = ({ shortName, renderType = "new" }) =>
  httpCall({
    method: AppConstants.httpMethod.GET,
    headers: getAuthHeaders(),
    url: ACTIVITY_ENDPOINTS.fetchActivityFields(shortName, renderType),
  });

export const fetchActivityById = ({ activityId }) =>
  httpCall({
    method: AppConstants.httpMethod.GET,
    headers: getAuthHeaders(),
    url: ACTIVITY_ENDPOINTS.fetchActivityById(activityId),
  });

export const fetchSkillsetTags = () =>
  httpCall({
    method: AppConstants.httpMethod.GET,
    headers: getAuthHeaders(),
    url: ACTIVITY_ENDPOINTS.fetchSkillsetTags(),
  });

export const createActivity = (payload) =>
  httpCall({
    method: AppConstants.httpMethod.POST,
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
    url: ACTIVITY_ENDPOINTS.createActivity(),
    data: payload,
  }, true);

export const updateActivity = (payload) => {
  const activityId = payload?.activity?.activity_id ??payload?.activity_id ?? payload?.activityId

  return  httpCall({
    method: AppConstants.httpMethod.PUT,
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
    url: ACTIVITY_ENDPOINTS.updateActivity(activityId),
    data: payload,
  }, true)
};